import axios from "axios";

import { handleRequestError } from "@/components/Utils/handleRequestError";

export async function CREATE_RENDER(data) {
  const url = `/api/v1/services/render360/`;
  try {
    const resp = await axios.post(url, data);
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function GET_RENDER_BY_ID(id) {
  const url = `/api/v1/services/render360/${id}/`;
  try {
    const resp = await axios.get(url);
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function CANCEL_RENDERS(renders) {
  const url = `/api/v1/services/render360/revoked/`;
  const uuids = renders.map((r) => r.uuid);
  const data = {
    render_projects_uuid: uuids,
  };

  try {
    const resp = await axios.post(url, data);
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function DELETE_RENDERS(renders) {
  const url = `/api/v1/services/render360/bulk_delete/`;
  const uuids = renders.map((r) => r.uuid);
  const data = {
    render_projects_uuid: uuids,
  };

  try {
    const resp = await axios.delete(url, { data });
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function DELETE_RENDER(renderUUID) {
  const url = `/api/v1/services/render360/${renderUUID}/`;
  try {
    const resp = await axios.delete(url);
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function GENERATE_PREVIEW_API(render) {
  const url = `/api/v1/services/render360/${render.uuid}/preview/`;
  try {
    const resp = await axios.post(url);
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function START_RENDER(render) {
  const url = `/api/v1/services/render360/${render.uuid}/render/`;
  try {
    const resp = await axios.post(url);
    return resp.data;
  } catch (error) {
    handleRequestError(error);
  }
}

export async function LOAD_MANY_RENDERS(renders) {
  const url = "/api/v1/services/render360/download_many/";

  const rendersForLoad = (renders || []).filter((r) => r && r.status === "success" && r.uuid);

  if (!rendersForLoad.length) {
    console.warn("No renders with 'success' status", renders);
    return { ok: false, error: "Нет рендеров, готовых к скачиванию" };
  }

  const payload = { render_projects_uuid: rendersForLoad.map((r) => r.uuid) };

  try {
    const res = await axios.post(url, payload, {
      responseType: "blob", // получаем поток как Blob
      timeout: 0, // не обрываем долгую выгрузку
      // withCredentials: true,                   // <- раскомментируйте, если нужен cookie/сессия
    });

    // пробуем достать имя файла
    let filename = `renders_${_tsForFilename("Europe/Moscow")}.zip`;
    const cd = res.headers["content-disposition"] || res.headers["Content-Disposition"];
    if (cd) {
      const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
      if (m) filename = decodeURIComponent(m[1] || m[2]);
    }
    // если нужен доступ к заголовку из браузера при CORS —
    // бэк должен отдать: Access-Control-Expose-Headers: Content-Disposition

    // если бэк по ошибке вернул JSON, а не файл — покажем сообщение
    const ctype = (res.headers["content-type"] || "").toLowerCase();
    if (ctype.includes("application/json")) {
      const text = (await res.data.text?.()) ?? (await new Response(res.data).text());
      throw new Error(text);
    }

    // скачиваем
    const blob = res.data;
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(href);

    return { ok: true, filename };
  } catch (err) {
    try {
      // пытаемся форматировать ошибку
      let errorText = JSON.parse(await err.response.data.text());
      console.log(errorText);
      errorText = "Не удалось скачать рендеры:<br>" + errorText.failure.join("<br>");
      return { ok: false, error: errorText };
    } catch {
      // noop
    }

    // аккуратно вытаскиваем текст ошибки даже если это Blob
    if (err?.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text();
        console.error("Download failed:", text);
        return { ok: false, error: text };
      } catch {
        // noop
      }
    }
    console.error("Download failed:", err);
    return { ok: false, error: err?.message || String(err) };
  }
}

function _tsForFilename(tz) {
  const d = new Date();
  const fmt = new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: tz,
  });

  const parts = Object.fromEntries(fmt.formatToParts(d).map((p) => [p.type, p.value]));
  const day = parts.day;
  const mon = parts.month.replace(".", "").toLowerCase(); // "окт." -> "окт"
  const hh = parts.hour.padStart(2, "0");
  const mm = parts.minute.padStart(2, "0");

  return `${day}${mon}_${hh}-${mm}`; // например: 21окт_14-22
}
